import Button from "components/base/Button";
import { CurrencyContext } from "CurrencyProvider";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import EditCostView from "./EditCostView";
import { GearContext } from "./GearDetailPage";

const CostView = () => {
  const { id, gearData, save } = useContext(GearContext);
  const { usdExchangeRates } = useContext(CurrencyContext);

  const prices = gearData.prices.map((i) => {
    const priceInUsd =
      gearData.currency === "USD"
        ? i.price
        : parseFloat(i.price) / usdExchangeRates[gearData.currency];
    return { ...i, priceInUsd };
  });

  const modal = useModals();

  function editHandler() {
    const initialValues = {
      supplierName: gearData.supplierName,
      supplierId: gearData.supplierId,
      leadtime: gearData.leadtime,
      currency: gearData.currency,
      moq: gearData.moq,
      prices: gearData.prices,
      notes: gearData.notes,
    };

    modal.present({
      title: "Edit Supplier & Cost",
      children: (
        <EditCostView
          id={id}
          initialValues={initialValues}
          hide={modal.hide}
          saveHandler={saveHandler}
        />
      ),
    });
  }

  function saveHandler(newValues) {
    modal.hide();

    const newGearData = { ...gearData, ...newValues };
    save({
      variables: {
        id,
        gearData: JSON.stringify(newGearData, " ", 2),
      },
    });
  }

  return (
    <div className="card">
      <div className="flex justify-between items-center space-x-6">
        <h5>Supplier & Cost</h5>
        <div>
          <Button onClick={editHandler}>Edit</Button>
        </div>
      </div>

      <div className="mt-4 space-y-4">
        <div className="flex items-center space-x-8">
          <div className="space-x-2">
            <label>Supplier: </label>
            <span>{gearData.supplierName || "N/A"}</span>
          </div>

          <div className="space-x-2">
            <label>MOQ: </label>
            <span>{gearData.moq}</span>
          </div>

          <div className="space-x-2">
            <label>Leadtime: </label>
            <span>{gearData.leadtime} days</span>
          </div>
        </div>

        <div className="-mx-2 ">
          <table>
            <tbody>
              {prices.map((price, index) => (
                <tr
                  key={index}
                  price={price}
                  className="border-y border-gray-100 whitespace-nowrap"
                >
                  <td className="w-full">
                    <label>For Quantity: </label>
                    <span>{price.qty}</span>
                  </td>
                  <td className="text-right">
                    {gearData.currency} {parseFloat(price.price).toFixed(2)} /
                    unit
                  </td>
                  {gearData.currency !== "USD" && (
                    <td className="text-right">
                      USD {price.priceInUsd.toFixed(2)} / unit
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="opacity-70">
                  Currency Rate Today: {usdExchangeRates[gearData.currency]}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div>
          <label>Notes:</label>
          <div className="mt-2 whitespace-pre-wrap">
            {gearData.notes || "-"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostView;
